import React from "react";
import { SelectedUserContext } from "./SelectedUserContext.js";

export function useSelectedUser() {
  return React.useContext(SelectedUserContext);
}
